import { gql } from "@apollo/client";
import { useResettableMutation } from "../useResettableMutation";
import { getErrors } from "../../utils/apolloError";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { ApprovePermitToDig, ApprovePermitToDigVariables } from "./__generated__/ApprovePermitToDig";
import { PERMIT_TO_DIG_ALL_FIELDS } from "../fragments/permitToDig";

const APPROVE_PERMIT = gql`
  ${PERMIT_TO_DIG_ALL_FIELDS}
  mutation ApprovePermitToDig($id: String!, $permitRegisterId: String!, $permitTypeId: String!) {
    approvePermitToDig(input: { id: $id, permitRegisterId: $permitRegisterId, permitTypeId: $permitTypeId }) {
      permitToDig {
        ...PermitToDigAllFields
      }
    }
  }
`;

export function useApprovePermit() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    ApprovePermitToDig,
    ApprovePermitToDigVariables
  >(APPROVE_PERMIT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
